module.exports = __webpack_public_path__ + "static/media/S5P1_discrimination.6cfd1b6c.mp3";